import ScanCoupon from 'views/ScanCoupon';
import { FunctionComponent } from 'react';
import LogIn from 'views/LogIn';
import Card from 'views/Card';
import Coupon from 'views/Coupon';
import GiveStamps from 'views/GiveStamps';
import Clients from 'views/Clients';
import GraphicMaterial from 'views/GraphicMaterial';

export type Route = {
  title: string;
  path: string;
  component: FunctionComponent;
  exact: boolean;
  private: boolean;
};

const routes: Route[] = [
  {
    title: 'GraphicMaterial',
    path: '/material',
    component: GraphicMaterial,
    exact: true,
    private: true,
  },
  {
    title: 'Home',
    path: '/',
    component: Clients,
    exact: true,
    private: true,
  },
  {
    title: 'Scan Coupon',
    path: '/scan-coupon',
    component: ScanCoupon,
    exact: true,
    private: true,
  },
  {
    title: 'Show QR',
    path: '/give-stamps',
    component: GiveStamps,
    exact: true,
    private: true,
  },
  {
    title: 'Log In',
    path: '/log-in',
    component: LogIn,
    exact: true,
    private: false,
  },
  {
    title: 'Card',
    path: '/cards/:cardId',
    component: Card,
    exact: true,
    private: true,
  },
  {
    title: 'Coupon',
    path: '/coupon/:id',
    component: Coupon,
    exact: true,
    private: true,
  },
];
export default routes;
